import {validators} from '~/shared/utils/validators';

export const shouldRequireAddressPhoneUpdate = (userPhone: string, addressPhone: string) => {
  const isUserHasValidCellphone = !validators.addressPhoneNumberValidator(userPhone);
  const isAddressPhoneValid = !validators.addressPhoneNumberValidator(addressPhone);

  return isUserHasValidCellphone ? !isUserHasValidCellphone : !isAddressPhoneValid;
};
